import React, { useEffect, useState } from "react";
import { useModal } from "react-modal-hook";
import { Button } from "../../Common/Button";
import { CommonModal } from "../../Common/CommonModal";
import Modal from "../../Common/Modal";

export const useExportModal = () => {
  const [modalProps, setModalProps] = useState<
    Maybe<{
      title: string;
      message: string;
    }>
  >(null);

  const [showModal, hideModal] = useModal(() => {
    const onClose = () => setModalProps(null);
    return (
      <Modal onRequestClose={onClose}>
        <CommonModal
          title={modalProps?.title || ""}
          content={modalProps?.message}
          onCancel={onClose}
        />
      </Modal>
    );
  }, [modalProps]);

  useEffect(() => {
    if (modalProps) {
      showModal();
    } else {
      hideModal();
    }
  }, [modalProps, showModal, hideModal]);

  return {
    setModalProps,
  };
};

export const ExportButton = ({
  onClickExport,
  ariaLabel,
}: {
  onClickExport: () => Promise<void>;
  ariaLabel: string;
}) => {
  return (
    <Button
      onClick={onClickExport}
      size="small"
      styleVariant="outlineLight"
      aria-label={ariaLabel}
      leftIconName="download"
    >
      Export
    </Button>
  );
};
